import React, { useEffect, useContext } from 'react'
import { connect } from 'react-redux'
import DesignSummaryModalMobile from 'components/DesignSummaryModalMobile'
import DesignSummaryModal from 'components/DesignSummaryModal'
import { func, bool, string, arrayOf } from 'prop-types'
import {
    getSelectedComposition,
    getSelectedCompositionShoppableProductData,
    getSelectedCompositionRenderedItemsTotalPrice,
    getSelectedCompositionRenderItemsLocalIds,
    getIsModified,
    getIsSaving,
} from 'models/compositions/selectors'
import { getHasAddedToBag } from 'models/bag/selectors'

import { compositionType, productsDataType } from 'models/propTypes'
import { addRoomToBag as addRoomToBagAction, openBag as openBagAction } from 'models/bag/actions'
import { showToast as showToastAction, hideToast as hideToastAction } from 'models/toasts/actions'
import { getOrientation } from 'models/ui/selectors'
import { requestFavorites as requestFavoritesAction } from 'models/favorites/actions'
import SugarcubeContext from 'apps/SugarcubeContext'
import { openDesignLab as openDesignLabAction } from 'models/ui/actions'
import { getIsLoggedIn } from 'models/user/selectors'
import { saveSelectedComposition as saveSelectedCompositionAction } from 'models/compositions/actions'

const DesignSummaryModalContainer = ({
    closeModal,
    composition,
    addedToRoomItems,
    addRoomToBag,
    hasAddedToBag,
    openBag,
    totalPrice,
    localItemNumbers,
    showToast,
    orientation,
    hideToast,
    onCloseMagicWindow,
    openExitPopup,
    requestFavorites,
    isModified,
    openDesignLab,
    isLoggedIn,
    isSaving,
    saveSelectedComposition,
}) => {
    useEffect(() => {
        requestFavorites()
    }, [])
    const { isMobile, ikeaNav, isMagicWindow } = useContext(SugarcubeContext)
    const productIds = addedToRoomItems.map((item) => item.localItemNumber)
    const region = addedToRoomItems.length ? addedToRoomItems[0].region : null
    const trackingInfo = { ProductsAdded: addedToRoomItems.length }
    const blockRedirect = true
    return isMobile ? (
        <DesignSummaryModalMobile
            closeModal={closeModal}
            composition={composition}
            addRoomToBag={() => addRoomToBag(productIds, region, trackingInfo, blockRedirect)}
            hasAddedToBag={hasAddedToBag}
            openBag={openBag}
            totalPrice={totalPrice}
            localItemNumbers={localItemNumbers}
            showToast={showToast}
            hideToast={hideToast}
            addedToRoomItems={addedToRoomItems}
            orientation={orientation}
            onCloseMagicWindow={onCloseMagicWindow}
            openExitPopup={openExitPopup}
        />
    ) : (
        <DesignSummaryModal
            closeModal={closeModal}
            composition={composition}
            addRoomToBag={() => addRoomToBag(productIds, region, trackingInfo, blockRedirect)}
            hasAddedToBag={hasAddedToBag}
            openBag={openBag}
            totalPrice={totalPrice}
            localItemNumbers={localItemNumbers}
            addedToRoomItems={addedToRoomItems}
            openExitPopup={openExitPopup}
            isModified={isModified}
            ikeaNav={ikeaNav}
            openDesignLab={openDesignLab}
            isMagicWindow={isMagicWindow}
            onCloseMagicWindow={onCloseMagicWindow}
            isLoggedIn={isLoggedIn}
            isSaving={isSaving}
            onSave={saveSelectedComposition}
        />
    )
}

DesignSummaryModalContainer.defaultProps = {
    localItemNumbers: null,
    onCloseMagicWindow: null,
}

DesignSummaryModalContainer.propTypes = {
    closeModal: func.isRequired,
    composition: compositionType.isRequired,
    addedToRoomItems: productsDataType.isRequired,
    addRoomToBag: func.isRequired,
    openBag: func.isRequired,
    hasAddedToBag: bool.isRequired,
    totalPrice: string.isRequired,
    localItemNumbers: arrayOf(string),
    showToast: func.isRequired,
    hideToast: func.isRequired,
    orientation: string.isRequired,
    onCloseMagicWindow: func,
    openExitPopup: func.isRequired,
    requestFavorites: func.isRequired,
    isModified: bool.isRequired,
    openDesignLab: func.isRequired,
    isLoggedIn: bool.isRequired,
    isSaving: bool.isRequired,
    saveSelectedComposition: func.isRequired,
}

const mapStateToProps = (state) => ({
    composition: getSelectedComposition(state),
    addedToRoomItems: getSelectedCompositionShoppableProductData(state),
    hasAddedToBag: getHasAddedToBag(state),
    totalPrice: getSelectedCompositionRenderedItemsTotalPrice(state),
    localItemNumbers: getSelectedCompositionRenderItemsLocalIds(state),
    orientation: getOrientation(state),
    isModified: getIsModified(state),
    isLoggedIn: getIsLoggedIn(state),
    isSaving: getIsSaving(state),
})

const mapDispatchToProps = {
    addRoomToBag: addRoomToBagAction,
    openBag: openBagAction,
    showToast: showToastAction,
    hideToast: hideToastAction,
    requestFavorites: requestFavoritesAction,
    openDesignLab: openDesignLabAction,
    saveSelectedComposition: saveSelectedCompositionAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(DesignSummaryModalContainer)
